import { PatientGuarantorAddress } from "pwapi";

export const checkGuarantorAddress = (
  address?: Partial<PatientGuarantorAddress>
) => {
  return address &&
    Object.keys(address).filter(
      (key) => address[key as keyof PatientGuarantorAddress]
    ).length > 0
    ? address
    : undefined;
};

export const formatSSN = (value: string) => {
  if (!value) return value;

  // Remove all non-digit characters
  const digits = value.replace(/\D/g, "");

  // Format as XXX-XX-XXXX
  if (digits.length <= 3) return digits;
  if (digits.length <= 5) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5, 9)}`;
};

export const formatPhone = (value: string) => {
  if (!value) return value;

  // Remove all dashes
  const cleaned = value.replace(/-/g, "");

  // Format as XXX-XXX-XXXX, allowing for any characters after to
  // account for extensions
  if (cleaned.length <= 3) return cleaned;
  if (cleaned.length <= 6) return `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
  return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
};
